function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, InputNumber, Modal, Alert, Upload } from "antd";
import Common from '../includes/Common';
import Webcam from "react-webcam";
import { HandIndexFill, ArrowClockwise } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var AddDeliveryReport = function AddDeliveryReport(_ref) {
  var handler = _ref.handler,
    order = _ref.order;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    deliveryImage = _useState8[0],
    setDeliveryImage = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var saveDelivery = function saveDelivery(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    if (deliveryImage == null) {
      setFormError("Veuillez capturer une photo du bon");
      return;
    }
    var formData = new FormData();
    formData.append('quantity', values.quantity);
    formData.append('external_ref', values.external_ref);
    formData.append('proof', deliveryImage);
    formData.append('received_quantity', values.received_quantity);
    formData.append('order_id', order.id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'adddeliveryreport', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    confirm({
      title: 'Confirmez-vous la livraison ?',
      content: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Fournisseur: "
            }), " ", order.provider.label, " "]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Quantit\xE9: "
            }), " ", values.received_quantity.toLocaleString('Fr'), " LITRES"]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Produit: "
            }), " ", order.product.label, " "]
          })]
        })
      }),
      onOk: function onOk() {
        saveDelivery(values);
      }
    });
  };
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      style: {
        background: '#FFCE00'
      },
      children: ["Livraison de carburant pour la commande N\xBA", /*#__PURE__*/_jsx("b", {
        children: order.id
      }), " de ", /*#__PURE__*/_jsx("b", {
        children: order.quantity.toLocaleString('Fr')
      }), " Litres avec ", /*#__PURE__*/_jsx("b", {
        children: order.provider.label
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "external_ref",
        label: "N. Bon de livraison",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          style: {
            width: '200px'
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "received_quantity",
        label: "Qt\xE9 re\xE7u",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "LITRES",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), deliveryImage == null ? /*#__PURE__*/_jsx(Webcam, {
        audio: false,
        height: 300,
        mirrored: true,
        screenshotFormat: "image/jpeg",
        width: 380,
        children: function children(_ref2) {
          var getScreenshot = _ref2.getScreenshot;
          return /*#__PURE__*/_jsx(Button, {
            type: "default",
            icon: /*#__PURE__*/_jsx(HandIndexFill, {
              size: 22
            }),
            onClick: function onClick() {
              var imageSrc = getScreenshot();
              setDeliveryImage(imageSrc);
            },
            children: "Capturer le bon"
          });
        }
      }) : /*#__PURE__*/_jsxs("div", {
        style: {
          width: '380px'
        },
        children: [/*#__PURE__*/_jsx("img", {
          src: deliveryImage
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            setDeliveryImage(null);
          },
          icon: /*#__PURE__*/_jsx(ArrowClockwise, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Reprendre"
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disable: deliveryImage,
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER LA LIVRAISON"
          })
        })
      })]
    })]
  });
};
export default AddDeliveryReport;